export function getOrderDetailPath(orderId: string) {
  return `/orders/${encodeURIComponent(orderId)}`;
}

export function getOrderDetailLinkProps(orderId: string) {
  return {
    href: getOrderDetailPath(orderId),
    target: "_blank",
    rel: "noopener noreferrer",
  };
}
